import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'

export const welfareConfig: WelfarePageConfig = {
  theme: {
    btnBg: '#E4587F',
    btnText: '#FFFFFF',
    coinsColor: '#C9A227',
    coinsGradient: 'linear-gradient(135deg, #EFCE7A 0%, #C9A227 100%)',
    actionGradient: 'linear-gradient(135deg, #F492AC 0%, #E05A7E 100%)',
    checkinBtnGradient: 'linear-gradient(135deg, #F492AC 0%, #E05A7E 100%)',
  },
  resources: {
    homeBg: '/images/novelyn/welfare-bg.svg',
    welfareGold: '/images/novelyn/coin.svg',
    welfareBox: '/images/novelyn/gift.svg',
  },
  texts: welfareCommonConfig.texts,
}
